import {HttpClient, HttpHeaders, HttpParams} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {AndroidBridgeBase} from "../../../../mobile/api-services/bridge/android-bridge-base";
import {Constraints, HttpMethod, Platform} from "../../../../constraints";
import {CasaMobileBaseService} from "./casa-mobile-base.service";

@Injectable({
  providedIn: 'root'
})
export class CasaAndroidService extends CasaMobileBaseService {
  private readonly apiEndpoint = Constraints.androidGenericInternalApiEndpoint;
  private readonly baseUrl = `${this.apiEndpoint}/platform/${Platform.Events}`;

  constructor(
    private http: HttpClient,
    private bridgeBase: AndroidBridgeBase,
  ) {
    super();
  }

  private nextRequestIdHeader() {
    const id = this.bridgeBase.getNextRequestId();
    return new HttpHeaders({"X-Request-Id": id.toString()});
  }

  protected request<T>(method: HttpMethod, path: string, body?: any, params?: HttpParams): Observable<T> {
    return this.http.request<T>(method, `${this.baseUrl}${path}`, {
      body: body ?? undefined,
      params: params ?? undefined,
      headers: this.nextRequestIdHeader(),
    });
  }
}
